import axios from "axios";
import { ActiveExperimentsResponse } from "redmond";

import { experimentsApiPrefix } from "../paths";
import { config } from "../../config";

// Corporate (COBT) LaunchDarkly project experiment values. Used on the capone
// (consumer) tenant for multi-portal users so trips experiments resolve from
// the corporate project rather than the consumer one. Same response shape as
// the regular /api/v0/experiments/active endpoint.
const END_POINT: string = `${experimentsApiPrefix}/cobt/active`;

export const fetchCobtActiveExperiments =
  (): Promise<ActiveExperimentsResponse> =>
    new Promise(async (resolve, reject) => {
      try {
        const res = await axios.put(END_POINT, {}, { baseURL: config.baseURL });
        resolve(res.data);
      } catch (e) {
        reject(e);
      }
    });
